import { connect } from "react-redux";

import { dismissAnnouncement } from "actions/announcements";
import { getFacilitiesChoiceListAction, getPracticeChoiceListAction } from "actions/choiceLists";
import { clearErrorsAction } from "actions/errors";
import { clearApplicationAction, logoutUserAction } from "actions/logout";
import { setUserPreferenceAction } from "actions/setUserPreference";
import { buildNewEncounterChoiceListsAction } from "scenes/Encounter/actions/buildChoiceLists";
import { getRecoveredEncountersCountAction } from "scenes/RecoveredEncounters/actions/recoveredEncountersAction";

import { AppWrapper } from "./AppWrapper";

import type { State } from "reducers";

const mapStateToProps = (state: State) => ({
  errors: state.ui.errors,
  choiceLists: state.choiceLists,
  user: state.user,
  encounter: state.encounter,
  announcements: state.announcements,
  recoveredEncounters: state.recoveredEncounters,
});

const getFacilitiesChoiceList = () =>
  getFacilitiesChoiceListAction(false, "loadingNewEncounterFacilities");
const getPracticeChoiceList = () =>
  getPracticeChoiceListAction(false, "loadingNewEncounterPractices");

const mapDispatchToProps = {
  clearApplication: clearApplicationAction,
  logoutUser: logoutUserAction,
  clearErrors: clearErrorsAction,
  buildNewEncounterChoiceLists: buildNewEncounterChoiceListsAction,
  saveUserPreference: setUserPreferenceAction,
  getFacilitiesChoiceList,
  getPracticeChoiceList,
  dismissAnnouncement,
  refreshRecoveredEncountersCount: getRecoveredEncountersCountAction,
};

export const AppWrapperContainer = connect(mapStateToProps, mapDispatchToProps)(AppWrapper);
